module.exports = __webpack_public_path__ + "img/accessory_item_15.2b107a60.svg";